module.exports = __webpack_public_path__ + "static/img/icon1-4.c15b9423.svg";